import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../../../slices/thunks";
// import { Col, Container, Nav, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck, faWeightHanging } from '@fortawesome/free-solid-svg-icons';
import "./AboutUs.scss";
import Navbar from "./navbar";
import Footer from "./footer";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  TruckIcon,
  FileText,
  Barcode,
  Settings2,
  Users,
  Phone,
} from "lucide-react";
import PropTypes from "prop-types";
import "./AboutUs/AboutUs_MIssion.scss";

import weighbridge from "../../../assets/images/clients/weighbridge.png";
import tally from "../../../assets/images/clients/tally.png";
import rfid from "../../../assets/images/clients/rfid.png";
import epabx from "../../../assets/images/clients/epabx.jpg";
import attendance from "../../../assets/images/clients/attendance.png";
import secureye from "../../../assets/images/clients/secureye.png";
import client1 from "../../../assets/images/clients/client-1.png";
import client2 from "../../../assets/images/clients/client-2.png";
import client3 from "../../../assets/images/clients/client-3.jpg";
import client4 from "../../../assets/images/clients/client-4.png";
import client5 from "../../../assets/images/clients/client-5.png";
import client6 from "../../../assets/images/clients/client-6.png";


import { FaBalanceScale, FaFileInvoiceDollar, FaBarcode, FaMoneyCheckAlt, FaFingerprint, FaKey, FaPhoneAlt, FaCogs, FaCamera, FaVideo } from "react-icons/fa";



const contents = [
  {
    title: "Weigh Bridge Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "SMEs not even think to systemize their business operations without integration with WeighBridges.",
      "Zero the chance of revenue leakage being done by weighment operator in your organization."
    ],
    icon: FaBalanceScale,
  },
  {
    title: "Accounting Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Push your Vouchers into the Tally Accounting software with ease.",
      "Save time and eliminate manual errors then go through with Tax Practitioners for return filling."
    ],
    icon: FaFileInvoiceDollar,
  },
  {
    title: "RFID Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Our Hotel PMS is ready to work with RFID cards.",
      "You can manage your food court with Prepaid RFID card POS System.",
      "With a very cost-effective solution, you can prevent revenue loss in your organization."
    ],
    icon: FaBarcode,
  },
  {
    title: "Payment Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Give your customers the freedom to pay online.",
      "Our ERP provides integrations with multiple leading online payment service providers.",
      "Accept online payments from the popular digital wallets without any hassles."
    ],
    icon: FaMoneyCheckAlt,
  },
  {
    title: "Attendance Machine Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Tell your employees to touch their finger once with attendance machines.",
      "Leave the rest to us.",
      "Do not waste time preparing salary statements by manual attendance."
    ],
    icon: FaFingerprint,
  },
  {
    title: "Room Lock Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Integrate your key card programmer with hotel PMS.",
      "Control your room lock with our PMS.",
      "No need to double the check-in/check-out entry with another software."
    ],
    icon: FaKey,
  },
  {
    title: "EPABX Integrations",
    image: [weighbridge, tally, attendance],
    text: [
      "Integrate your Telephone EPABX System with hotel PMS.",
      "Let it auto-download the SMDR data to the server.",
      "Save revenue by controlling telephone misuse."
    ],
    icon: FaPhoneAlt,
  },
  {
    title: "PLC Gate",
    image: [weighbridge, tally, attendance],
    text: [
      "Automate gate operations with PLC Gate integration.",
      "Ensure precise vehicle tracking, enhanced security, and real-time data.",
      "Enable efficient reporting and reduce operational errors."
    ],
    icon: FaCogs,
  },
  {
    title: "Cameras",
    image: [weighbridge, tally, attendance],
    text: [
      "Integrate cameras for real-time monitoring.",
      "Enhance security, streamline operations, and provide accurate visual data.",
      "Enable seamless reporting and error-free decision-making."
    ],
    icon: FaCamera,
  },
  // {
  //   title: "Hikvision",
  //   image: [weighbridge, tally, attendance],
  //   text: [
  //     "Integrate Hikvision cameras for advanced surveillance and real-time monitoring.",
  //     "Enhance security and ensure reliable visual data.",
  //     "Enable seamless operations and improved decision-making."
  //   ],
  //   icon: FaVideo,
  // },
  // {
  //   title: "Dahua",
  //   image: [weighbridge, tally, attendance],
  //   text: [
  //     "Integrate Dahua cameras for high-quality surveillance and real-time monitoring.",
  //     "Improve security and ensure reliable visual data.",
  //     "Enable efficient operations and accurate decision-making."
  //   ],
  //   icon: FaVideo,
  // },
  // {
  //   title: "CP Plus",
  //   image: [weighbridge, tally, attendance],
  //   text: [
  //     "Integrate CP Plus cameras for robust surveillance and real-time monitoring.",
  //     "Enhance security and ensure precise visual data.",
  //     "Enable efficient operations and accurate decision-making."
  //   ],
  //   icon: FaVideo,
  // },
  {
    title: "RFID",
    image: [weighbridge, tally, attendance],
    text: [
      "Integrate RFID for seamless asset tracking and real-time data capture.",
      "Improve security and enable efficient operations.",
      "Ensure accurate and automated processes across your business."
    ],
    icon: FaBarcode,
  },
];


const ContentItem = ({ item, index }) => {
  const IconComponent = item.icon;

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % item.image.length); // Loop back to the first slide
    }, 2000); // 2 seconds interval

    return () => clearInterval(slideInterval); // Cleanup on component unmount
  }, [item.image.length]);

  return (

    <Col md={6} lg={4} className="mb-4">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.1,
          delay: index * 0.001,
        }}
        viewport={{ once: true }}
      >
        <Card
          className="text-center border-0 shadow-sm"
          style={{
            height: "550px", // Adjusted height for slider
            borderRadius: "16px",
            background: "linear-gradient(135deg, #f8f9fa, #ffffff)",
          }}
        >
          {/* Icon Wrapper */}
          <motion.div
            className="d-flex justify-content-center align-items-center mx-auto"
            style={{
              width: "80px",
              height: "80px",
              marginTop: "-40px",
              background: "#007bff",
              borderRadius: "50%",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            }}
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <IconComponent size={40} style={{ color: "#ffffff", strokeWidth: "1.5" }} />
          </motion.div>

          {/* Card Body */}
          <Card.Body className="px-4 pt-4">
            <motion.h5
              className="mb-3"
              style={{ fontSize: "1.25rem", fontWeight: "600", color: "#333" }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: index * 0.2 + 0.1 }}
            >
              {item.title}
            </motion.h5>

            {/* Image Slider */}
            <div style={{ overflow: "hidden", width: "100%", height: "150px" }}>
              <div
                className="d-flex"
                style={{
                  width: `${item.image.length * 100}%`,
                  transition: "transform 0.5s ease-in-out",
                  transform: `translateX(-${currentSlide * (100 / item.image.length)}%)`,
                }}
              >
                {item.image.map((img, imgIndex) => (
                  <div
                    key={imgIndex}
                    style={{
                      flex: "0 0 auto",
                      width: `${100 / item.image.length}%`,
                      height: "150px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={img} // Ensure `img` is the URL or path to the image
                      alt={`Slide ${imgIndex + 1}`}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            <motion.ul
              className="text-muted"
              style={{
                fontSize: "1rem",
                color: "#666",
                listStyleType: "disc",
                paddingLeft: "1.5rem",
                textAlign: "left", // Ensures the text is left aligned
              }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: index * 0.2 + 0.1 }}
            >
              {item.text.map((sentence, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.1 }}
                  style={{ marginBottom: "0.5rem" }} // Add margin to create space between sentences
                >
                  {sentence}
                </motion.li>
              ))}
            </motion.ul>

            <p>Use Case</p>

          </Card.Body>
        </Card>
      </motion.div>
    </Col>
  );
};


ContentItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

const IndustrialIntegration = () => {
  const dispatch = useDispatch();
  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (layoutModeType) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);
  /*
call dark/light mode
*/
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this runs once when the component mounts
  return (
    <div
      style={{
        overflow: "hidden",
      }}
    >
      <Navbar
        onChangeLayoutMode={onChangeLayoutMode}
        layoutModeType={layoutModeType}
      />

      <motion.section
        className="ezy__howitworks3 py-5"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.1 }}
        viewport={{ once: true }}
      >
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1 }}
            viewport={{ once: true }}
          >
            <Row className="justify-content-center text-center mb-5 mt-5">
              <Col xl={8} lg={10}>
                <h1 className="ezy__howitworks3-heading text-primary display-4 mb-3">
                  Our Integrations
                </h1>
                <p className="ezy__howitworks3-sub-heading lead text-muted">
                  Unlock the full potential of your business with our cutting-edge
                  automation solutions. Seamless integrations, unparalleled
                  support, and customizable options - we've got you covered.
                </p>
              </Col>
            </Row>
          </motion.div>

          <Row>
            {contents.map((item, index) => (
              <ContentItem key={item.title} item={item} index={index} />
            ))}
          </Row>
        </Container>
      </motion.section>
      <Footer />
    </div>
  );
};
export default IndustrialIntegration;
